"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import _ from "underscore";
import CarrierName from "../carrier_name";
import CarrierTypeAhead from "../carrier_typeahead";
import ReactUtils from "../../react_utils";
const bem = ReactUtils.makeBem("carrier-chooser");
function onSelectionChange(props, index) {
  props.onUpdate(_.extend(_.clone(props.state), { selectedIndex: index }));
}
function onNoCarrierSelectionChange(props) {
  props.onUpdate({
    typeAheadCarrier: null,
    selectedIndex: null
  });
}
function typeAheadCarrierSelected(props, carrier) {
  props.onUpdate({
    typeAheadCarrier: carrier,
    selectedIndex: props.carrierGuesses.length
  });
}
function typeAheadCarrierCleared(props) {
  props.onUpdate(__spreadProps(__spreadValues({}, props.state), {
    typeAheadCarrier: null
  }));
}
function guessedCarrier(props, guess, index) {
  return /* @__PURE__ */ React.createElement("div", { className: bem("__choice"), key: `guess_${guess.carrierID}` }, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: bem("__guessed-radio") + " mousetrap",
      name: "carrier",
      onChange: () => onSelectionChange(props, index),
      checked: props.state.selectedIndex === index,
      type: "radio"
    }
  ), /* @__PURE__ */ React.createElement("div", { className: bem("__guessed-carrier") }, /* @__PURE__ */ React.createElement(CarrierName, { carrierID: guess.carrierID }), " (", guess.context, ")"));
}
function indexCustomerOnlyDocuments(props) {
  if (props.allowIndexingCustomerOnlyDocuments) {
    return /* @__PURE__ */ React.createElement("div", { className: bem("__choice") }, /* @__PURE__ */ React.createElement(
      "input",
      {
        className: bem("__guessed-radio") + " mousetrap",
        name: "carrier",
        checked: props.state.selectedIndex === null,
        onChange: () => onNoCarrierSelectionChange(props),
        type: "radio"
      }
    ), /* @__PURE__ */ React.createElement("div", { className: bem("__guessed-carrier") }, /* @__PURE__ */ React.createElement("p", null, "Assign documents to load without assigning a carrier")));
  }
}
export default React.createClass({
  statics: {
    initialState: function() {
      return {
        selectedIndex: 0,
        typeAheadCarrier: null
      };
    },
    selectedCarrierID: function(state, carrierGuesses) {
      if (state.selectedIndex == null) {
        return null;
      } else if (state.selectedIndex < carrierGuesses.length) {
        return carrierGuesses[state.selectedIndex].carrierID;
      } else if (state.typeAheadCarrier) {
        return state.typeAheadCarrier.id;
      }
    },
    assignCustomerOnlyDocuments: function(state) {
      if (state.selectedIndex == null) {
        return true;
      } else {
        return false;
      }
    }
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem() }, _.map(
      this.props.carrierGuesses,
      (guess, index) => guessedCarrier(this.props, guess, index)
    ), /* @__PURE__ */ React.createElement("div", { className: bem("__choice") }, /* @__PURE__ */ React.createElement(
      "input",
      {
        className: bem("__typeahead-radio") + " mousetrap",
        name: "carrier",
        checked: this.props.state.selectedIndex === this.props.carrierGuesses.length,
        onChange: () => onSelectionChange(this.props, this.props.carrierGuesses.length),
        type: "radio"
      }
    ), /* @__PURE__ */ React.createElement("div", { className: bem("__typeahead") }, /* @__PURE__ */ React.createElement(
      CarrierTypeAhead,
      {
        onSelectCarrier: (carrier) => typeAheadCarrierSelected(this.props, carrier),
        onClearCarrier: () => typeAheadCarrierCleared(this.props),
        onFocus: () => onSelectionChange(this.props, this.props.carrierGuesses.length),
        carrier: this.props.state.typeAheadCarrier
      }
    ))), indexCustomerOnlyDocuments(this.props));
  }
});
